import { useIsAuthenticated } from "@azure/msal-react";
import { useContext, useState } from "react";
import { Nav } from "react-bootstrap";
import Navbar from "react-bootstrap/Navbar";
import { NavLink } from "react-router-dom";
import adminlogo from "../../assets/adminlogo.png";
import seequent from "../../assets/seequent.png";
import { SignInMenuOption } from "../Login/SignInMenuOption";
import { SignOutMenuOption } from "../Login/SignOutMenuOption";
import { useStyles } from "./Header.styles";

import { ParkLordContext } from "../../App";
import { useTheme } from "../../ThemeContext";
import { CharityModal } from "../GenericModal/GenericModal";
/**
 * Renders the navbar component with a sign-in button if a user is not authenticated
 */
export const Header = () => {
    const isAuthenticated = useIsAuthenticated();
    const { classes } = useStyles();
    const [expanded, setExpanded] = useState(false)
    const parkLord = useContext(ParkLordContext)
    const [showDonationModal, setShowDonationModal] = useState(false);
    const { darkMode, toggleDarkMode } = useTheme();

    const handleDonationCloseModal = async () => {
        setShowDonationModal(false)
    }

    return (
        <>
        <Navbar expanded={expanded} collapseOnSelect expand="lg" bg="black" variant="dark" className={classes.nav}>
            <Navbar.Brand href="/" className="my-1">
                <img className="d-inline-block align-top" height="30" src={seequent} alt="Seequent logo" />
            </Navbar.Brand>
            <Navbar.Toggle onClick={() => setExpanded(!expanded)} aria-controls="responsive-navbar-nav" />
            <Navbar.Collapse id="responsive-navbar-nav" className="justify-content-end">
                <Nav hidden={!isAuthenticated}>
                    <Nav.Link
                        as="button"
                        type="button"
                        style={{ color: "orange" }}
                        onClick={() => { setExpanded(false); setShowDonationModal(true); }}
                    >
                        <i className="bi bi-cash-coin me-2"></i>Donate Here
                    </Nav.Link>
                    <Nav.Link
                        as="button"
                        type="button"
                        aria-pressed={darkMode}
                        aria-label={darkMode ? "Disable dark mode" : "Enable dark mode"}
                        style={{ color: "#adb5bd" }}
                        onClick={() => { setExpanded(false); toggleDarkMode(); }}
                    >
                        <i className={`bi ${darkMode ? "bi-sun" : "bi-moon"} me-2`}></i>Change appearance
                    </Nav.Link>
                    <Nav.Link as={NavLink} to="/" href="#" onClick={() => {setExpanded(false)}}><i className="bi bi-calendar2-week me-2"></i>Book A Park</Nav.Link>
                    <Nav.Link as={NavLink} to="/myparks" href="#myparks" onClick={() => {setExpanded(false)}} ><i className="bi bi-car-front me-2"></i>Manage My Park</Nav.Link>
                    <Nav.Link as={NavLink} to="/parkmap" href="#parkmap" onClick={() => {setExpanded(false)}} ><i className="bi bi-map me-2"></i>Park Map</Nav.Link>
                    <Nav.Link as={NavLink} to="/about" href="#about" onClick={() => {setExpanded(false)}} ><i className="bi bi-info-circle me-2"></i>About Us</Nav.Link>
                    {parkLord?.adminBool && (<Nav.Link as={NavLink} to="/admin" href="#admin" onClick={() => { setExpanded(false) }} > <img height="20" src={adminlogo}/>Admin Dashboard</Nav.Link>)}
                </Nav>
                <Nav>
                    {isAuthenticated ? <SignOutMenuOption /> : <SignInMenuOption />}
                </Nav>
            </Navbar.Collapse>
        </Navbar>

        <CharityModal props={{ title: "ParkSeeq charities you can support", show: showDonationModal, handleClose: handleDonationCloseModal }}></CharityModal>
        </>
    );
};
